import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material';
import { Navigation } from './components/Navigation';
import { AppRoutes } from './routes';
import { useNavigationStore } from './store/navigationStore';

const DRAWER_WIDTH = 240;
const COLLAPSED_DRAWER_WIDTH = 72;

const App: React.FC = () => {
  const { isMenuExpanded } = useNavigationStore();
  console.log('-----');
  return (
    <Router>
      <Box 
        sx={{ 
          display: 'flex',
          minHeight: '100vh',
          width: '100%',
          bgcolor: 'background.default',
          overflow: 'hidden'
        }}
      >
        <Navigation />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'auto',
            width: { 
              sm: `calc(100% - ${isMenuExpanded ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH}px)` 
            },
            transition: theme => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }}
        >
          <AppRoutes />
        </Box>
      </Box>
    </Router>
  );
};

export default App;